import { cardTonePill } from "@/lib/card-styles";
import { cn } from "@/lib/utils";

export function SimulatedConnectorBadge({ visible }: { visible: boolean }) {
  if (!visible) return null;
  return (
    <span
      className={cn(
        "relative rounded-full border px-2 py-0.5 text-[10.5px]",
        cardTonePill.learning,
      )}
    >
      Simuloitu
    </span>
  );
}
